/**
 * DevExtreme (esm/core/utils/size.js)
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export {
    getElementBoxParams,
    getSize,
    parseHeight,
    addOffsetToMaxHeight,
    addOffsetToMinHeight,
    getVerticalOffsets,
    getVisibleHeight,
    implementationsMap,
    getWidth,
    setWidth,
    getHeight,
    setHeight,
    getOuterWidth,
    setOuterWidth,
    getOuterHeight,
    setOuterHeight,
    getInnerWidth,
    setInnerWidth,
    getInnerHeight,
    setInnerHeight,
    getWindowByElement,
    getOffset
}
from "../../__internal/core/utils/m_size";
